import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bulletin-v2",
  "use": "icon-bulletin-v2-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-bulletin-v2\"><path d=\"M9 16v3a1 1 0 0 1-1 1h-.382a1 1 0 0 1-.894-.553L5 16h4zm-1-2V7h3.695l.099-.004c.343-.028.674-.147.958-.344l4.733-3.294A2 2 0 0 1 18.627 3H19a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-.394a2 2 0 0 1-1.11-.336l-5.08-3.387A1.651 1.651 0 0 0 11.5 14H8zM6 7v7H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h2z\" fill=\"#A4B4D0\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol